import { useDispatch, useSelector } from "react-redux";
import { useSaveAlertBannerMutation } from "app/store/transmission/api/transmissionTableApi";
import { changeProfileField } from "app/store/transmission/slice/transmissionSlice";

import { showToast } from "utils/toast";
import { cloneDeep, debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";

const useAlertBannerTab = () => {
  const { alertBanner, originalAlertBanner, patientSerialNumber } = useSelector(
    (state) => state.transmission
  );
  const { currentUser } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const [alertBannerText, setAlertBannerText] = useState("");

  const [saveAlertBanner, { isLoading: isSubmitting }] =
    useSaveAlertBannerMutation();

  useEffect(() => {
    setAlertBannerText(alertBanner);
  }, [alertBanner]);

  const debouncedDispatch = useCallback(
    debounce((value) => {
      dispatch(
        changeProfileField({
          type: "alertBanner",
          value,
        })
      );
    }, 500),
    []
  );

  const handleAlertBannerTextChange = (value) => {
    setAlertBannerText(value);
    debouncedDispatch(value);
  };

  const handleBanner = async () => {
    try {
      const result = await saveAlertBanner({
        serialNumber: patientSerialNumber,
        bannerText: alertBanner,
      }).unwrap();

      if (result?.data) {
        updateOriginalAlertBanner();
        showToast({ message: result?.message });
      }
    } catch (error) {
      showToast({ message: error.message, type: "error" });
    }
  };

  const updateOriginalAlertBanner = () => {
    const bannerTextCopy = cloneDeep(alertBanner);

    dispatch(
      changeProfileField({
        type: "originalAlertBanner",
        value: bannerTextCopy,
      })
    );
  };

  const handleCancel = async () => {
    const bannerTextCopy = cloneDeep(originalAlertBanner);
    handleAlertBannerTextChange(bannerTextCopy);
  };

  return {
    currentUser,
    alertBannerText,
    isSubmitting,
    handleBanner,
    handleCancel,
    handleAlertBannerTextChange,
  };
};

export default useAlertBannerTab;
